import { ProjectsViewOptions } from "../../../projects/components/ProjectsViewSelect"
import { ProjectColumnName } from "../../../treegrid/project-list/types"

type ProjectListView = Exclude<ProjectsViewOptions, "templates"> // The templates view is not rendered in the project list, it has its own treegrid

export const projectListDefaultColumnOrderByView: Record<ProjectListView, ProjectColumnName[]> = {
  currentAndFuture: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "participants",
    "suppliers",
    "workspaces",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "completionPercentage",
    "completionPercentageBasedOnTasks",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
    "actualBarStartDate",
    "actualBarEndDate",
    "ganttGanttHtmlRight",
    "ganttRun",
  ],
  all: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "participants",
    "suppliers",
    "workspaces",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "rejectedDate",
    "status",
    "completionPercentage",
    "completionPercentageBasedOnTasks",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
    "actualBarStartDate",
    "actualBarEndDate",
    "ganttGanttHtmlRight",
    "ganttRun",
  ],
  completed: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "participants",
    "suppliers",
    "workspaces",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "completionPercentage",
    "completionPercentageBasedOnTasks",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
  ],
  archived: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "participants",
    "suppliers",
    "workspaces",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "rejectedDate",
    "status",
    "completionPercentage",
    "completionPercentageBasedOnTasks",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
  ],
  rejected: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "plannedStartDate",
    "plannedEndDate",
    "participants",
    "suppliers",
    "workspaces",
    "actualStartDate",
    "actualEndDate",
    "rejectedDate",
    "status",
    "completionPercentage",
    "completionPercentageBasedOnTasks",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
  ],
}

// This list also needs to be ordered according to how the columns should be ordered in the UI
export const projectListDefaultVisibleColumnsByView: Record<ProjectListView, ProjectColumnName[]> = {
  currentAndFuture: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "plannedStartDate",
    "plannedEndDate",
    "status",
    "completionPercentage",
    "statusDescription",
  ],
  all: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "completionPercentage",
    "statusDescription",
  ],
  completed: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "actualEndDate",
    "statusDescription",
    "description",
  ],
  archived: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "statusDescription",
    "description",
  ],
  rejected: [
    "open",
    "customers",
    "projectNumber",
    "title",
    "managers",
    "rejectedDate",
    "statusDescription",
    "description",
  ],
}
